import { Injectable } from '@angular/core';
import { ExperimentType } from '../core-data-model';
import { InitDataService } from '../system-services/InitData';

@Injectable({ providedIn: 'root' })
export class ExperimentAccessControlService {
    constructor(private initData: InitDataService) {}

    getExperimentStatus(experiment: ExperimentType): boolean {
        return this.initData.hasExperimentAccess(experiment);
    }
}
